import React from 'react';
import I18n from 'i18n-js';

import { CSP } from '../../../schemas/rql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCStarRating } from '@reverbdotcom/cadence/components';

export interface IProps {
  csp?: CSP;
}

export default class ListingSidebarCSPCard extends React.Component<IProps, null> {

  getCSPImageStyle() {
    if (!this.props.csp.image.source) return null;

    return { backgroundImage: `url(${this.props.csp.image.source})` };
  }

  renderPrices() {
    const { csp } = this.props;
    const tags = {
      tagOpen: '<b>',
      tagClose: '</b>',
    };

    const { usedLowPrice } = csp.inventory;
    const { newLowPrice } = csp.inventory;

    return (
      <ul className="csp-sidebar-card__prices">
        {usedLowPrice &&
          <SanitizedRender
            className="csp-sidebar-card__price"
            htmlTag="li"
            html={I18n.t('discovery.comparisonShoppingPages.listingSidebar.usedPriceFrom',
              { price: usedLowPrice.display, ...tags })
            }
          />
        }
        {newLowPrice &&
          <SanitizedRender
            className="csp-sidebar-card__price"
            htmlTag="li"
            html={I18n.t('discovery.comparisonShoppingPages.listingSidebar.newPriceFrom',
              { price: newLowPrice.display, ...tags })
            }
          />
        }
      </ul>
    );
  }

  renderPlaceholder() {
    return (
      <div className="csp-sidebar-card csp-sidebar-card--placeholder">
        <div className="csp-sidebar-card__inner">
          <div className="csp-sidebar-card__content">
            <div className="csp-sidebar-card__content__img">
              <div className="csp-sidebar-card__content__img__inner" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { csp } = this.props;
    if (!csp) return this.renderPlaceholder();

    return (
      <article className="csp-sidebar-card">
        <CoreLink
          className="csp-sidebar-card__inner"
          to={this.props.csp.webLink.href}
          entityId={this.props.csp.id}
        >
          <div className="csp-sidebar-card__content">
            <div
              className="csp-sidebar-card__content__img"
            >
              <div
                className="csp-sidebar-card__content__img__inner"
                style={this.getCSPImageStyle()}
              />
            </div>
            <div className="csp-sidebar-card__content__details">
              <h4 className="csp-sidebar-card__content__title">
                {csp.title}
              </h4>
              {!!this.props.csp.reviews.avgRating &&
                <div className="mb-half">
                  <RCStarRating
                    rating={this.props.csp.reviews.avgRating / 5.0}
                    count={this.props.csp.reviews.total}
                  />
                </div>
              }
              {this.renderPrices()}
            </div>
          </div>
          <div className="csp-sidebar-card__compare-cta">
            {I18n.t('discovery.comparisonShoppingPages.listingSidebar.comparePrices')}
          </div>
        </CoreLink>
      </article>
    );
  }
}
